import { Component } from '@angular/core';

import {
  BusinessTypeComponent,
  CompanyRoleComponent,
  ContactTypeComponent,
  CriticityComponent,
  CriticityStatus,
  CultureComponent,
  DepartmentIconListComponent,
  DepartmentProfessionsComponent,
} from '@camelot/ui';
import { Culture } from '@camelot/utils';

import { TestIdDirective } from '@camelot/testing-harness';

@Component({
    imports: [
        BusinessTypeComponent,
        CompanyRoleComponent,
        ContactTypeComponent,
        CriticityComponent,
        CultureComponent,
        DepartmentIconListComponent,
        DepartmentProfessionsComponent,
        TestIdDirective,
    ],
    template: `
    <cam-business-type camTestId="cam-business-type" [businessType]="1" />
    <cam-company-role camTestId="cam-company-role" [companyRole]="1" />
    <cam-contact-type camTestId="cam-contact-type" [contactType]="1" />
    <cam-criticity camTestId="cam-criticity" [criticity]="this.criticity" />
    <cam-culture camTestId="cam-culture" [cultures]="this.cultures" />
    <cam-department-icon-list camTestId="cam-department-icon-list" [departments]="this.departments" />
    <cam-department-professions camTestId="cam-department-professions" [professions]="this.professions" />
  `
})
export class UiEnumsCase {
  public criticity = CriticityStatus.P1;
  public cultures = [Culture.FR_BE, Culture.EN_EN];
  public departments = [{ iconPath: null, id: 1, name: 'Department one' }];
  public professions = ['Plumber', 'Electrician'];
}
